import { render, staticRenderFns } from "./OctothorpeFooter.vue?vue&type=template&id=4857cdf8&scoped=true&"
import script from "./OctothorpeFooter.vue?vue&type=script&lang=js&"
export * from "./OctothorpeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857cdf8",
  null
  
)

export default component.exports